module.exports = __webpack_public_path__ + "static/media/APOLLOTYRE.f79896e2.txt";